import React, { Component } from "react";
import View from "./view";
import "./index.css";
import { getStoreComments, getStore } from "../../../backend/stores";
import { withRouter } from "react-router-dom";
import { updateRoute } from "../../../redux/actions";
import { connect } from "react-redux";

class CommentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      storeLocation: "",
      loading: false,
      storeSelect: null
    };
    this._change = this._change.bind(this);
    this._navigate = this._navigate.bind(this);
    this._selectStore = this._selectStore.bind(this);
  }

  async componentDidMount() {
    if (this.props.match.params.store_id) {
      this.setState({ loading: true });
      let store = await getStore(this.props.match.params.store_id);
      this.setState({
        comments: await getStoreComments(this.props.match.params.store_id),
        loading: false,
        storeSelect: { label: store.name, value: store.id }
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.store_id !== this.props.match.params.store_id) {
      this.setState({ loading: true });

      let { name = null, id = null } = (await getStore(
        this.props.match.params.store_id
      )) || { name: null, id: null };

      this.setState({
        storeSelect: { label: name, value: id },
        comments: await getStoreComments(this.props.match.params.store_id),
        loading: false
      });
    }
  }

  render() {
    return View.call(this);
  }

  _change(prop) {
    return event => this.setState({ [prop]: event.target.value });
  }

  _selectStore({ value, label }) {
    this.setState({ storeSelect: { value, label } });
    this._navigate(`/stores/${value}`)();
    this.props.updateRoute(value);
  }

  _renderStoreComment(
    { id, created_at, inspection_note, priority, store_id },
    key
  ) {
    return (
      <div
        key={key}
        className={`comment ${priority}`}
        onClick={this._navigate(`/comment-form/${store_id}/${id}`)}
      >
        <div className="note">{inspection_note}</div>
        <div className="status">{priority}</div>
        <div className="last-inspection">{created_at}</div>
      </div>
    );
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateRoute: store_id => {
      dispatch(updateRoute("stores", `/stores/${store_id}`));
      dispatch(updateRoute("machines", `/machines/${store_id}`));
      dispatch(updateRoute("create", `/comment-form/${store_id}`));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CommentList)
);



// WEBPACK FOOTER //
// ./src/screens/stores/comment-list/index.js